import { connect, ConnectedProps } from 'react-redux'
import TopLevelAccordion from 'components/accordion/TopLevelAccordion'
import { setAccordionIsLoaded } from 'redux/actions'
import { AppDispatch, RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { group: RootState['accordion']['group'], eventCategory: RootState['accordion']['eventCategory'], expandedNodeId: RootState['accordion']['expandedNodeId'], highlight: RootState['accordion']['highlight'] } => ({
  group: state.accordion.group,
  eventCategory: state.accordion.eventCategory,
  expandedNodeId: state.accordion.expandedNodeId,
  highlight: state.accordion.highlight
})

const mapDispatchToProps = (dispatch: AppDispatch): { setAccordionIsLoaded: (isLoaded: boolean) => ReturnType<AppDispatch> } => ({
  setAccordionIsLoaded: (isLoaded: boolean) => dispatch(setAccordionIsLoaded(isLoaded))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type TopLevelAccordionContainerProps = ConnectedProps<typeof connector>

export default connector(TopLevelAccordion)
